<header>
  <h1 class="title">Task Details</h1>
  <button (click)="close()">
    <svg-icon class="close" src="/assets/icons/cross-thing.svg"></svg-icon>
  </button>
</header>

<section class="details">
  <div class="details-row">
    <div class="details-title">Task ID:&nbsp;<span *ngIf="serviceType() === 'dc'">(Batch name)</span></div>
    <div class="details-value">{{order.id}}</div>
  </div>
  <div class="details-row">
    <div class="details-title">Creation date:&nbsp;</div>
    <div class="details-value">{{order.created | date:'d MMM h:mm a'}}</div>
  </div>
  <div class="details-row">
    <div class="details-title">Application ID:&nbsp;</div>
    <div class="details-value">{{order.application}}</div>
  </div>
</section>
